import qs from 'qs';

import { log, time, timeEnd } from 'utils/console';

import SirDidymus from './didymus';

const name = 'tuning-fork-redirect';
const options = qs.parse(window.location.search.substr(1));

time(`${name} / initialize`);
(function initialize() {
    log(name, 'initialize');
    SirDidymus.verify(options);
    setTimeout(() => {
        timeEnd(`${name} / initialize`);
    });
})();
